function validateColumnExcelData({ excelData, column, validate }) {
  if (!excelData) return false;
  return excelData.reduce(
    (acc, current) => acc && validate(current[column]),
    true,
  );
}

export default validateColumnExcelData;
